import { useEffect } from 'react';
import { useGlobalContext } from 'app/Context/GlobalContext';
import { initializeFCM } from 'app/utils/fcm';

export const FCMListener = ({ firebaseApp }: { firebaseApp: any }) => {
  const { setRefreshNotifications } = useGlobalContext();

  useEffect(() => {
    if (process.env.REACT_APP_FCM_ENABLED === 'true') {
      try {
        initializeFCM(firebaseApp, setRefreshNotifications);
        console.log('FCM listener set up successfully');
      } catch (error) {
        console.error('Error setting up FCM listener: ', error);
      } finally {
        setRefreshNotifications(false);
        console.log('FCM listener setup complete');
      }
    }
  }, []);

  return null;
};
